import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "badge text-bg-warning fs-13 me-5 mt-10"
}
const _hoisted_9 = {
  key: 1,
  class: "badge text-bg-info fs-13 me-5 mt-10"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  class: "modal fade",
  id: "modal-ville",
  tabindex: "-1",
  "aria-labelledby": "modalVilleLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog modal-lg" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args))),
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          }, _cache[10] || (_cache[10] = [
            _createTextVNode(" Nouvelle demande ", -1),
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Search ",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter())),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.headers,
          rows: _ctx.rows
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [11]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field == 'created_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
              : (props.column.field === 'type')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    (props.row.type == 'SIMPLE_PARCEL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Colis Simple "))
                      : _createCommentVNode("", true),
                    (props.row.type == 'SIMPLE_STOCK')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Colis de stock "))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field === 'statut')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass([`fs-13 me-5 mt-10 badge text-bg-${_ctx.resolveUStatus(0)}`, "text-capitalize"])
                      }, _toDisplayString(props.row.statut), 3)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users,
          offset: 9,
          onPaginate: _ctx.fetchData
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRequest && _ctx.submitRequest(...args)), ["prevent"]))
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h5", {
                class: "modal-title",
                id: "modalVilleLabel"
              }, "Nouvelle Demande"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "type_request",
                  class: "form-label"
                }, "Type de ramassage *", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "type_request",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type_request) = $event)),
                  required: ""
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("option", {
                    value: "",
                    disabled: ""
                  }, "Choisir le type", -1),
                  _createElementVNode("option", { value: "SIMPLE_PARCEL" }, "Ramassage Colis", -1),
                  _createElementVNode("option", { value: "SIMPLE_STOCK" }, "Ramassage Stock", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.type_request]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  for: "phone",
                  class: "form-label"
                }, "Téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "phone",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event)),
                  placeholder: "Téléphone*",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  for: "city",
                  class: "form-label"
                }, "Ville de reception *", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  modelValue: _ctx.city,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.city) = $event)),
                  label: "name",
                  options: _ctx.citiesList,
                  required: ""
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  for: "adresse",
                  class: "form-label"
                }, "Adresse", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "adresse",
                  class: "form-control",
                  rows: "2",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.adresse) = $event)),
                  placeholder: "Adresse*"
                }, null, 512), [
                  [_vModelText, _ctx.adresse]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  for: "remarque",
                  class: "form-label"
                }, "Remarque", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "remarque",
                  class: "form-control",
                  rows: "2",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.remarque) = $event)),
                  placeholder: "Remarque*"
                }, null, 512), [
                  [_vModelText, _ctx.remarque]
                ])
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-footer" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                "data-bs-dismiss": "modal"
              }, " Annuler "),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-success"
              }, " Enregistrer ")
            ], -1))
          ], 32)
        ])
      ])
    ])
  ], 64))
}